<template>
  <form id="customer_form" class="checkout-form">
    <div class="form-header">
      <h5>{{ $t("checkout.customer") }}</h5>
    </div>
    <div class="form-body">
      <div v-if="cart">
        <form @change="validateForm">
          <ValidationObserver ref="observer" slim>
            <div class="row">
              <div class="col-md-6">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, valid, validated }"
                  :name="$t('checkout.firstname')"
                  slim
                >
                  <b-form-group
                    :invalid-feedback="errors[0]"
                    :state="validated ? valid : undefined"
                    :label="$t('checkout.firstname')"
                    label-class="label-required"
                    label-for="first-name"
                  >
                    <b-form-input
                      id="first-name"
                      v-model.lazy="customer_first_name"
                      :value="customer.first_name"
                      :state="validated ? valid : undefined"
                      name="first_name"
                      type="text"
                      :placeholder="$t('checkout.firstname')"
                    />
                  </b-form-group>
                </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, valid, validated }"
                  :name="$t('checkout.lastname')"
                  slim
                >
                  <b-form-group
                    :invalid-feedback="errors[0]"
                    :state="validated ? valid : undefined"
                    :label="$t('checkout.lastname')"
                    label-class="label-required"
                    label-for="last-name"
                  >
                    <b-form-input
                      id="last-name"
                      v-model.lazy="customer_last_name"
                      :value="customer.last_name"
                      :state="validated ? valid : undefined"
                      name="last_name"
                      type="text"
                      :placeholder="$t('checkout.lastname')"
                    />
                  </b-form-group>
                </ValidationProvider>
              </div>
            </div>
            <ValidationProvider
              rules="required|email"
              v-slot="{ errors, valid, validated }"
              :name="$t('checkout.email')"
              vid="email"
              slim
            >
              <b-form-group
                :invalid-feedback="errors[0]"
                :state="validated ? valid : undefined"
                :label="$t('checkout.email')"
                label-class="label-required"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model.lazy="customer_email"
                  :state="validated ? valid : undefined"
                  name="email"
                  type="text"
                  :placeholder="$t('checkout.email')"
                />
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider
              rules="required|email|emailAgain:email"
              v-if="requires.email_retype"
              v-slot="{ errors, valid, validated }"
              :name="$t('checkout.emailretype')"
              slim
            >
              <b-form-group
                :invalid-feedback="errors[0]"
                :state="validated ? valid : undefined"
                :label="$t('checkout.emailretype')"
                label-class="label-required"
                label-for="email_retype"
              >
                <b-form-input
                  id="email"
                  v-model.lazy="customer_email_retype"
                  :state="validated ? valid : undefined"
                  name="email_retype"
                  type="text"
                  :placeholder="$t('checkout.emailretype')"
                />
              </b-form-group>
            </ValidationProvider>

            <CustomFields @change="validateForm" />

            <b-form-group v-if="requires.marketing_optin.enabled">
              <b-form-checkbox id="marketing_optin" v-model="marketing_optin">
                {{ requires.marketing_optin.message }}
              </b-form-checkbox>
            </b-form-group>
          </ValidationObserver>
        </form>
      </div>
    </div>
  </form>
</template>

<script>
/* ============
 * Checkout/Customer Component
 * ============
 *
 * Gives an idea how components work.
 */
import { mapState } from "vuex";
import { sync } from "vuex-pathify";

import CustomFields from "@/components/cart/CustomFields";

export default {
  /**
   * The name of the component.
   */
  name: "CheckoutCustomer",

  components: {
    CustomFields,
  },

  /**
   * The computed properties that the component can use.
   */
  computed: {
    ...mapState({
      cart: (state) => state.cart,
      customer: "customer",
      custom_fields: "custom_fields",
      requires: "requires",
    }),
    customer_first_name: sync("customer@first_name"),
    customer_last_name: sync("customer@last_name"),
    customer_email: sync("customer@email"),
    customer_email_retype: sync("customer@email_retype"),
    marketing_optin: sync("customer@marketing_optin"),
  },

  methods: {
    updateCustomerMarketingOptin(e) {
      this.$store.dispatch("setCustomerMarketingOptin", e.target.checked);
    },
    async validateForm() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        let loader = this.$loading.show();
        await this.$store.dispatch("postCustomer");
        loader.hide();
        //console.log("update customer!");
      }
    },
  },
};
</script>
